

import { Link, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { Header } from "../Header/Header"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Footer } from "../../Footer/Footer"
import { LicentiateCertificateDDL } from "../../CommonDDL/LicentiateCertificateDDL"
import { LicentiateCertificateSubMenuDDL } from "../../CommonDDL/LicentiateCertificateSubMenuDDL"



export const Webinars = ({ actives }) => {

    const navigate = useNavigate()

    const [copiedId, setCopiedId] = useState(false)
    const [copiedPass, setCopiedPass] = useState(false)

    const handleCopy = (text, type) => {
        navigator.clipboard.writeText(text)
        if (type === 'id') {
            setCopiedId(true)
            setTimeout(() => setCopiedId(false), 2000)
        } else if (type === 'pass') {
            setCopiedPass(true)
            setTimeout(() => setCopiedPass(false), 2000)
        }
    }

    const webinarData = [
        {
            id: 1,
            title: "Fundamentals of Hull insurance part 3",
            date: "8",
            month: "Aug",
            dayTime: "Friday, 8 Aug  10:30 AM (India)",
            meetingId: "836 6969 9560",
            passcode: "7Fb0nT",
            WebinarLink: "https://us05web.zoom.us/j/83669699560?pwd=Q6u2e6oP7ntzLHrRdjvl5205Uz00Hh.1"  // Valid
        }
        // {
        //     id: 2,
        //     title: "Q & A Session",
        //     date: "1",
        //     month: "Aug",
        //     dayTime: "Friday, 1 Aug  11:00 – 11:40 PM (India)",
        //     meetingId: "832 4829 9162",
        //     passcode: "2DheDZ",
        //     WebinarLink: "https://us05web.zoom.us/j/83248299162?pwd=W8XdTpfxapPo6aQEXaEAXJ9xjFvT8Y.1"
        // },

    ];



    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="Webinars" subactive="Events" />

                        <HerosectionsAll ScreenName="Webinars" ScreenSearch="Webinars" />


                        {/* flyer image */}
                        <div className="row col-lg-11 mx-auto mt-3 mb-0 ">
                            <div className="row justify-content-center">
                                <div className="text-center py-3 rounded"
                                    style={{
                                        backgroundColor: '#16374e',
                                        width: '100%',
                                        // height: '450px'
                                    }}
                                >
                                    <h5 className="fw-bold text-white pb-2 ">Upcoming Webinar</h5>
                                    {/* <img
                                        src="Static/Assets/Img/Webinars/seminarimage.jpeg"
                                        alt="MILSO July 2026 Seminar"
                                        className="img-fluid rounded"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            boxShadow: '10px 10px #cd9e53'
                                        }}
                                    /> */}
                                    <iframe
                                        src="Static/Assets/Img/Webinars/Milso_July_2026_seminar-1-2-pages-1-merged.pdf#zoom=50"
                                        title="MILSO January 2026 Seminar"
                                        style={{
                                            width: '100%',
                                            // height: '50vh',
                                            minHeight: '600px',
                                            border: 'none',
                                            boxShadow: '10px 10px #cd9e53'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="container mt-3 p-4 rounded shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>


                            <div className="row align-items-center mt-3">

                                {/* Left Side Content */}
                                <div className="col-md-7">
                                    <h2 className="fw-bold text-primary">Webinar Series: <br />Fundamentals of Marine Hull & Machinery Insurance</h2>
                                    <p className="lead mt-3">Unlock the World of Marine Insurance — One Session at a Time</p>
                                    <p>
                                        Join us for an exclusive <strong>10-part webinar series</strong> designed to introduce and deepen your understanding
                                        of the Fundamentals of Marine Hull & Machinery Insurance — a crucial domain in the maritime and insurance industries.
                                    </p>
                                    <p>
                                        Whether you're a student, a professional entering the marine sector, or someone curious about how massive vessels and complex machinery are insured,
                                        this series is your gateway to learning from industry experts.
                                    </p>



                                    {/* <div className="border rounded p-3 mb-4 shadow-sm" style={{ borderColor: '#ddd', backgroundColor: '#f9f9f9' }}>

                                    <div className="d-flex align-items-center">

                                        <div style={{
                                            backgroundColor: '#f4c2c2',
                                            borderRadius: '8px',
                                            width: '65px',
                                            height: '65px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#5a5a5a', textTransform: 'uppercase' }}>Aug</div>
                                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#222' }}>1</div>
                                        </div>


                                        <div>
                                            <div className="fw-bold" style={{ fontSize: '18px', color: '#333' }}>
                                                Fundamentals of Marine Hull & Machinery Insurance
                                            </div>
                                            <div style={{ fontSize: '15px', color: '#514d4d' }}>
                                                Friday, 1 Aug  10:00 – 1:00 PM (India)
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="my-3" />
                                    <div>
                                        <div className="mb-2">
                                            <strong>Meeting ID : </strong> <span style={{ color: '#333' }}>891 3501 9906</span>
                                            <i
                                                className="fas fa-copy ms-2"
                                                style={{ cursor: 'pointer', color: '#95989bff' }}
                                                onClick={() => handleCopy('891 3501 9906', 'id')}
                                                title="Copy Meeting ID"
                                            ></i>
                                            {copiedId && <span className="ms-2 text-success">Copied</span>}
                                        </div>
                                        <div>
                                            <strong>Passcode : </strong> <span style={{ color: '#333' }}>6nYBVK</span>
                                            <i
                                                className="fas fa-copy ms-2"
                                                style={{ cursor: 'pointer', color: '#95989bff' }}
                                                onClick={() => handleCopy('6nYBVK', 'pass')}
                                                title="Copy Passcode"
                                            ></i>
                                            {copiedPass && <span className="ms-2 text-success">Copied</span>}
                                        </div>
                                    </div>
                                </div> */}

                                    {/* {webinarData.map((webinar, index) => (
                                        <div key={webinar.id} className="border rounded p-3 mb-2 shadow-sm" style={{ borderColor: '#ddd', backgroundColor: '#f9f9f9' }}>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    backgroundColor: '#f4c2c2',
                                                    borderRadius: '8px',
                                                    width: '65px',
                                                    height: '65px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginRight: '15px'
                                                }}>
                                                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#5a5a5a', textTransform: 'uppercase' }}>{webinar.month}</div>
                                                    <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#222' }}>{webinar.date}</div>
                                                </div>

                                                <div>
                                                    <div className="fw-bold" style={{ fontSize: '18px', color: '#333' }}>
                                                        {webinar.title}
                                                    </div>
                                                    <div style={{ fontSize: '15px', color: '#514d4d' }}>
                                                        {webinar.dayTime}<br />
                                                        Join Zoom Meeting
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className="my-3" />

                                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                <div>
                                                    <div className="mb-2">
                                                        <strong>Meeting ID : </strong> <span style={{ color: '#333' }}>{webinar.meetingId}</span>
                                                        <i
                                                            className="fas fa-copy ms-2"
                                                            style={{ cursor: 'pointer', color: '#95989bff' }}
                                                            onClick={() => handleCopy(webinar.meetingId, 'id')}
                                                            title="Copy Meeting ID"
                                                        ></i>
                                                        {copiedId && <span className="ms-2 text-success">Copied</span>}
                                                    </div>
                                                    <div>
                                                        <strong>Passcode : </strong> <span style={{ color: '#333' }}>{webinar.passcode}</span>
                                                        <i
                                                            className="fas fa-copy ms-2"
                                                            style={{ cursor: 'pointer', color: '#95989bff' }}
                                                            onClick={() => handleCopy(webinar.passcode, 'pass')}
                                                            title="Copy Passcode"
                                                        ></i>
                                                        {copiedPass && <span className="ms-2 text-success">Copied</span>}
                                                    </div>
                                                </div>

                                                <div className="mt-2 mt-md-0">
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={() => window.open(webinar.WebinarLink)}
                                                    >
                                                        Join Webinar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))} */}



                                </div>

                                {/* Right Side Image (Optional or Themed Graphic) */}
                                <div className="col-md-5 col-lg-5 text-center mt-4 mt-md-0">
                                    <img src="Static/Assets/Img/Webinar_img.jpg" alt="Marine Insurance Webinar" className="img-fluid rounded shadow-sm ms-5" />
                                    {/* If image not ready, use placeholder: */}
                                    {/* <div className="bg-secondary rounded text-white p-5">Webinar Banner Here</div> */}
                                </div>

                            </div>

                        </div>



                        <Footer />
                    </div>
                </div>

            </div>
        </>
    )
}
